import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';

export const shouldShowCardModal = () => getQueryParams()?.action === 'add-card';
